import styled from 'styled-components';

export const CountdownWrapper = styled.div`
    margin-bottom: 16px;
`;

export const CountdownText = styled.p`
    text-transform: uppercase;
    font-weight: 800;
    color: ${({ theme }) => theme.colors.Color1};
`;
